

export default {
    name: 'DropDownMenu',
    props: {
        /**
         * Set toggle as a button
         */
        button: {
            type: Boolean,
        },
        /**
         * Set text of button
         */
        text: {
            type: String,
            default: 'toggle',
        },
        /**
         * Control background colour of icon
         */
        iconBackground: {
            type: Boolean,
            default: true,
        },
    },
};

